import React from "react";
import { Link } from "react-router-dom";
import "../styles/projects.css";
import { motion } from "framer-motion";

import { projects } from "./constants/index";

const Project = ({ theme, name, description, tags, source_code_link }) => {
  return (
    <div
      className="card"
      style={{
        backgroundColor: theme === "white" ? "white" : "black",
        color: theme === "white" ? "gray" : "gray",
      }}
    >
      <div className="project__about">
        <h3>{name}</h3>
        <p className="project__about__text">{description}</p>
        <div className="project__tags">
          {tags.map((tag, index) => (
            <p key={index}>{tag}</p>
          ))}
        </div>
      </div>
      <div className="project__links">
        <Link to={source_code_link}> Know More </Link>
        <svg
          fill="currentColor"
          height="1em"
          stroke="currentColor"
          strokeWidth="0"
          viewBox="0 0 1024 1024"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"></path>
        </svg>
      </div>
    </div>
  );
};

function Projects({ theme }) {
  return (
    <>
      <motion.div
      variants={{
        hidden:{opacity:0, y:75},
        visible:{opacity:1, y:0},

      }}
      initial="hidden"
      animate="visible"
      transition={{duration:0.5,delay:0.25}}
        className="project__main"
        style={{
          backgroundColor: theme === "white" ? "white" : "black",
          color: theme === "white" ? "gray" : "gray",
        }}
      >
        <h1 className="project__heading">Projects</h1>

        <div className="project__text">
          <div className="cards">
            {projects.map((project, index) => (
              <Project
                key={index}
                theme={theme}
                name={project.name}
                description={project.description}
                tags={project.tags}
                source_code_link={project.source_code_link}
              />
            ))}
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default Projects;
